import { render, staticRenderFns } from "./AllocationDetails.vue?vue&type=template&id=3f93f4fd&scoped=true"
import script from "./AllocationDetails.vue?vue&type=script&lang=js"
export * from "./AllocationDetails.vue?vue&type=script&lang=js"
import style0 from "./AllocationDetails.vue?vue&type=style&index=0&id=3f93f4fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f93f4fd",
  null
  
)

export default component.exports